<div [ngClass]="callingfrom === screenName.CHANNEL_DETAIL ? 'p-3 bg-white survey-channel-card position-relative bottom-radius' : 'p-3 bg-white survey-card position-relative'">
    <div class="position-absolute w-100 h-100 rounded-corner-12 prod-masking-div" *ngIf="surveyObj?.channel?.content_visibility?.display === contentVisibility.MASKING || surveyObj?.channel?.content_visibility?.display === contentVisibility.SUBMITTED">
      <app-product-masking-card [content_visibility]="surveyObj?.channel.content_visibility"></app-product-masking-card>
    </div>

   <div class="row">
    <div class="col-12"
      (click)="attemptSurvey()"
      [eventTracker]="{category: callingfrom,action: mls.googleEventText.survey_card.key5,product_type: surveyObj.product_type,product_id: surveyObj.product_type_id}"
      [ngClass]="{ 'cursor-pointer': surveyObj?.remark != 'completed' }">
      <p class="survey-title heading-4 mb-2"
        [ngClass]="{ 'cursor-pointer': surveyObj?.remark != 'completed' }">
        {{ surveyObj.title }}
      </p>
    </div>
   </div>
   <div class="row">
    <div class="col-12 d-flex align-items-center flex-column flex-md-row justify-content-start">
   <span class="secondary-paragraph mr-auto">
    <span class="clinical-compny">
      <img width="20px"
        class="rounded-circle mr-2"
        src="{{ surveyObj?.sponsored?.accreditation_url }}"
        onError="this.src='assets/images/icons/sponsor-default.svg'"/>
      <span class="color-grey-500">
        {{ mls.languageText.survey_card.key6 }}</span>
        <span class="color-grey-500" [innerHTML]="surveyObj?.sponsored?.accreditation"></span>
      </span>
  </span>
  </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-6 d-flex align-items-center">
    <span>
      <img width="20px" src="assets/themes/icons/survey_clock.svg" class="mr-2" alt="clock">
    </span>
    <span >
      <span class="secondary-paragraph color-grey-500">{{mls.languageText.survey_feed_card.key5}}</span>
      <span class="secondary-paragraph-bold"> : {{surveyObj?.end_date * 1000 | date : "d MMM y "}}</span>
    </span>
   </div>

   <div class="col-md-6 text-right ">
     <button class="btn-design small filled width cursor-pointer" (click)="attemptSurvey()">
       <span class="px-2">{{mls.languageText.survey_card.key2}}</span>
      </button>
   </div>
   </div>
  </div>
